import useOnScreen from '@src/hooks/useOnScreen'
import tracker from '@src/lib/tracker'
import React, { useEffect, useRef, useState } from 'react'

type TrackEventProps = {
  action: string | keyof typeof tracker | ((traits?: any) => void)
  allowDuplicates?: boolean
  traits?: any
  options?: any
  onlyOnScreen?: boolean
}

export const TrackEvent = (props: TrackEventProps) => {
  const onScreenRef = useRef<HTMLDivElement>(null)
  const isOnScreen = useOnScreen(onScreenRef)
  const [isMounted, setIsMounted] = useState<boolean>(false)
  const [callCount, setCallCount] = useState<number>(0)

  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true)
    }
  }, [])

  useEffect(() => {
    if (!isMounted) {
      return
    }

    if (props.onlyOnScreen && !isOnScreen) {
      return
    }

    if (props.allowDuplicates !== true && callCount > 0) {
      return
    }

    try {
      if (typeof props.action == 'function') {
        props.action(props.traits)
      } else if (typeof props.action === 'string') {
        if (typeof tracker[props.action] == 'function') {
          tracker[props.action](props.traits || {})
        } else {
          tracker.promisedTrack(props.action, props.traits || {}, props.options || {})
        }
      }
      setCallCount(count => count + 1)
    } catch (err) {
      console.log(err)
    }
  }, [isOnScreen, isMounted, callCount, props.action, props.allowDuplicates])

  if (props.onlyOnScreen) {
    return <div ref={onScreenRef} />
  } else {
    return <></>
  }
}
